import { useCallback } from 'react'

import wishlistStateManager from '@src/quince-site-common/src/redux/globalStateManager/WishlistStateManager'
import wishlistService from '@src/quince-site-common/src/services/wishlistService'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export const useProductWishList = () => {
  const isItemInWishList = useCallback((shopifyProductId: number, selectedColor: string) => {
    return wishlistService.isItemInWishlist(shopifyProductId, selectedColor)
  }, [])

  const removeItemFromWishList = useCallback(
    async (shopifyProductId: number, selectedColor: string, wishlistTrackConfig: Record<string, unknown>) => {
      //TODO: Handle tracking
      await wishlistService.removeFromWishlist(shopifyProductId, selectedColor)
      trackEvent(TELEMETRY_EVENT_NAMES.REMOVE_FROM_WISHLIST, wishlistTrackConfig)
      wishlistStateManager.setWishlistTotalItemsCount(wishlistService.getWishlistTotalItemsCount())
    },
    [],
  )

  const addItemToWishList = useCallback(
    //TODO: Handle tracking
    async (shopifyProductId: number, selectedColor: string, wishlistTrackConfig: Record<string, unknown>) => {
      await wishlistService.addItemToWishlist(shopifyProductId, selectedColor)
      trackEvent(TELEMETRY_EVENT_NAMES.ADD_TO_WISHLIST, wishlistTrackConfig)
      wishlistStateManager.setWishlistTotalItemsCount(wishlistService.getWishlistTotalItemsCount())
    },
    [],
  )
  return { isItemInWishList, addItemToWishList, removeItemFromWishList }
}
